// working in responsive 10 jan 2025
import React from "react";
import { useState, useEffect, useRef, useCallback } from "react";
import { useReactToPrint } from "react-to-print";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { MoonLoader } from "react-spinners";
import swal from "sweetalert";

import { handleInputs } from "../../../utils/HandleInputs";
import { showToast } from "../../../utils/ToastHelper";
import axios from "axios";
import { BASE_URL } from "../../Const/Url";
import * as path from "./../../Routes/RoutePaths";

import Loader from "../../CustomCommons/Loader";
import { can_add_invoice, has_permissions } from "../../CustomCommons/utils";
import Permission from "../../CustomCommons/Permission";
import Scanner2 from "./../Scanner2";
import PreviewCreate from "./../PreviewCreate";
import DoIcon from "../../CustomCommons/DoIcon";

import ProductDetails from "./ProductDetails";
import InvoiceDetails from "./InvoiceDetails";
import PaymentStatus from "./PaymentStatus";

import "./../invoice.css";

const VariantInvoice = () => {
  const [invoiceLoader, setInvoiceLoader] = useState(false);
  const [selectedVariants, setSelectedVariants] = useState({});
  const [deliveryService, setDeliveryService] = useState({
    label: "Pathao",
    value: 0,
  });

  const [FoundCustomer, setFoundCustomer] = useState({
    id: "",
    total_purchase: "",
    created_at: "",
    updated_at: "",
    name: "",
    mobile: "",
    email: "",
    status: "",
    address: "",
  });
  const [Found, setFound] = useState(false);
  // pathao data
  const [pathaoCity, setPathaoCity] = useState({
    label: "",
    value: "",
  });
  const [pathaoZone, setPathaoZone] = useState({
    label: "",
    value: "",
  });
  const [pathaoArea, setPathaoArea] = useState({
    label: "",
    value: "",
  });
  // pathao data
  const [selectedDivision, setSelectedDivision] = useState({
    label: "",
    value: "",
  });
  const [selectedDistrict, setSelectedDistrict] = useState({
    label: "",
    value: "",
  });
  const [selectedTown, setSelectedTown] = useState({ label: "", value: "" });
  const [selectLoading, setSelectLoading] = useState(false);
  // Address Form methods start
  const { register, control, watch, reset, setValue } = useForm();
  useEffect(() => {
    console.log(FoundCustomer, "found");
    if (Found) {
      SetInvoiceAllData((prevState) => ({
        ...prevState,
        invoice_bill_to: FoundCustomer.name,
      }));
      //  new changes
      if (FoundCustomer.redex_area) {
        setCustomCharge(
          Number(FoundCustomer?.redex_area_details.delivery_charge)
        );
        reset({
          division: {
            label: FoundCustomer.redex_division_details.name,
            value: FoundCustomer.redex_division_details.id,
          },
          district: {
            label: FoundCustomer.redex_district_details.name,
            value: FoundCustomer.redex_district_details.id,
          },
          town: {
            label: FoundCustomer.redex_area_details.name,
            value: FoundCustomer.redex_area_details.id,
          },
          // zip: { label: sInvoice.to_zip_code, value: sInvoice.to_zip_code }
          zip: FoundCustomer.to_zip_code,
        });
        setSelectedDivision({
          label: FoundCustomer.redex_division_details.name,
          value: FoundCustomer.redex_division_details.id,
        });
        setSelectedDistrict({
          label: FoundCustomer.redex_district_details.name,
          value: FoundCustomer.redex_district_details.id,
        });
        setSelectedTown({
          label: FoundCustomer.redex_area_details.name,
          value: FoundCustomer.redex_area_details.id,
        });
      } else {
        reset({
          division: { label: FoundCustomer.to_division, value: "" },
          district: { label: FoundCustomer.to_district, value: "" },
          town: { label: FoundCustomer.to_city, value: "" },
          // zip: { label: sInvoice.to_zip_code, value: sInvoice.to_zip_code }
          zip: FoundCustomer.to_zip_code,
        });
        setSelectedDivision({ label: FoundCustomer.to_division, value: "" });
        setSelectedDistrict({ label: FoundCustomer.to_district, value: "" });
        setSelectedTown({ label: FoundCustomer.to_city, value: "" });
      }
    }
  }, [Found, FoundCustomer, reset]);
  const [districtList, setDistrictList] = useState([]);
  const [upazillaList, setUpazillaList] = useState([]);
  const watchFields = watch([
    // "town",
    "division",
    "district",
    "town",
    "zip",
  ]);
  useEffect(() => {
    if (selectedDivision.value !== "") {
      axios
        .get(
          `${BASE_URL}/api/v1/utility/admin/redex-address/${selectedDivision.value}/`
        )
        .then((response) => {
          // setDistrictList(response.data.data.districts)
          if (response.data.data.districts !== undefined) {
            setDistrictList(response.data.data.districts);
          } else {
            setDistrictList([]);
          }
        });
    }
  }, [selectedDivision]);
  useEffect(() => {
    if (selectedDistrict.value !== undefined) {
      const foundAreas = districtList.filter(
        ({ id }) => id === selectedDistrict.value
      )[0]?.areas;
      // setUpazillaList(foundAreas)
      if (foundAreas !== undefined) {
        setUpazillaList(foundAreas);
      } else {
        setUpazillaList([]);
      }
    }
  }, [selectedDistrict, districtList]);
  const handleDivisionChange = (division) => {
    if (selectedDivision?.value !== undefined) {
      setSelectedDistrict({ label: "", value: "" });
      setSelectedTown({ label: "", value: "" });
      setValue("zip", "");
      setDistrictList([]);
      setSelectLoading(true);
      setCustomCharge(0);
      setSelectedDivision(division);
      setValue("division", division);
      const selectedDivisionId = division.value;
      axios
        .get(
          `${BASE_URL}/api/v1/utility/admin/redex-address/${selectedDivisionId}/`
        )
        .then((response) => {
          // setDistrictList(response.data.data.districts)
          if (response.data.data.districts !== undefined) {
            setDistrictList(response.data.data.districts);
          } else {
            setDistrictList([]);
          }
        });
    }
  };
  const handleDistrictChange = (district) => {
    if (selectedDistrict?.value !== undefined) {
      setSelectedTown({ label: "", value: "" });
      setValue("zip", "");
      setUpazillaList([]);
      setSelectLoading(false);
      setCustomCharge(0);
      setSelectedDistrict(district);
      setValue("district", district);
      const selectedDistrictId = district.value;
      const foundAreas = districtList.filter(
        ({ id }) => id === selectedDistrictId
      )[0]?.areas;
      // setUpazillaList(foundAreas)
      if (foundAreas !== undefined) {
        setUpazillaList(foundAreas);
      } else {
        setUpazillaList([]);
      }
    }
    // if (watchFields[2].label !== )
  };
  const handleTownChange = (town) => {
    if (selectedTown?.value !== undefined) {
      setValue("zip", "");
      setSelectedTown(town);
      setValue("town", town);
      const selectedAreaId = town.value;
      const foundDeliveryCharge = upazillaList?.filter(
        ({ id }) => id === selectedAreaId
      )[0]?.delivery_charge;
      // setCustomCharge(foundDeliveryCharge)
      if (foundDeliveryCharge !== undefined) {
        console.log(foundDeliveryCharge, selectedAreaId, "fdc");
        setCustomCharge(Number(foundDeliveryCharge));
      }
    }
  };

  const [scanedCode, setScanCode] = useState("");
  const [inputQuery, setInputQuery] = useState("");
  const mainEmail = "kaarujbangladesh@gmail.com";
  const mainName = "KAARUJ";
  const mainAddress = "Road: 42, Gulshan 2, Dhaka, Bangladesh";
  const mainMobile = "+8801980907892";
  const [isLoading, SetisLoading] = useState(false);
  const [defaultValue, setdefaultValue] = useState([]);

  const print = useRef();
  useEffect(() => {
    setScanCode("");
  }, []);
  const delivery_charge = {
    0: 80,
    1: 150,
  };
  const invoice_choices1 = [
    { value: 1, label: "Pending" },
    { value: 0, label: "Recieved" },
    { value: 2, label: "Refunded" },
  ];

  const delivery_choices = [
    { value: 3, label: "Pending" },
    { value: 1, label: "Order Placed" },
    { value: 0, label: "Returned" },
    { value: 2, label: "Delivered" },
    { value: 4, label: "Hold" },
    { value: 5, label: "Dispatched" },
  ];
  const paymentType = [
    { value: 0, label: "Cash On Delivery" },
    { value: 1, label: "Card" },
    { value: 2, label: "Bank Transfer" },
    { value: 3, label: "Bkash" },
    { value: 4, label: "SSLECOMMERZ" },
    { value: 5, label: "Nagad" },
    { value: 6, label: "Kaaruj Delivery" },
  ];
  const [pS, setPs] = useState(0);

  const [fromCode, setFromCode] = useState("880");
  const [toCode, setToCode] = useState("880");
  const [customCharge, setCustomCharge] = useState(80);
  console.log("crg", customCharge);
  const today = new Date();

  const formattedDate = today.toISOString().split("T")[0];
  const [InvoiceAllData, SetInvoiceAllData] = useState({
    invoice_date: formattedDate,
    invoice_due_date: "",
    invoice_bill_from: mainName,
    invoice_bill_to: "",
    invoice_from_mobile: mainMobile.replace("+880", ""),
    invoice_to_mobile: "",
    invoice_from_email: mainEmail,
    invoice_to_email: "",
    invoice_from_address: mainAddress,
    invoice_to_address: "",
    invoice_to_address2: "",
    to_zip_code: "",
    to_country: "Bangladesh",
    to_district: "",
    to_division: "",
    to_city: "",
    invoice_notes: "",
    invoice_delivery_charge: 0,
  });

  const [paymentAllData, setPaymentAllData] = useState({
    card_holder_name: "",
    card_number: "",
    bank_name: "",
    banK_account_number: "",
    banK_account_name: "",
    banK_branch_name: "",
    bkash_number: "",
    bkash_trx_number: "",
    nagad_number: "",
    nagad_trx_number: "",
    reference_id: "",
  });
  const clearPaymentALlData = () => {
    setPaymentAllData({
      card_holder_name: "",
      card_number: "",
      bank_name: "",
      banK_account_number: "",
      banK_account_name: "",
      banK_branch_name: "",
      bkash_number: "",
      bkash_trx_number: "",
      nagad_number: "",
      nagad_trx_number: "",
      reference_id: "",
    });
  };
  const [invoice_status, setinvoice_status] = useState(1);
  const [Delivery_status, setDelivey_status] = useState(3);
  const [invoice_delivery_type, setinvoice_delivery_type] = useState(0);
  const [invoice_discount_type, setinvoice_discount_type] = useState(1);
  const [invoice_payment_type, setinvoice_payment_type] = useState(0);
  const [invoice_delivery_charge, setinvoice_delivery_charge] = useState(2);
  // console.log("------------------------------");
  // console.log("invoice_payment_type", invoice_payment_type);
  // console.log("------------------------------");

  const [ProductsList, setProductsList] = useState([]);
  const [mainState, setMainState] = useState({});
  const [mainInnerState, setMainInnerState] = useState({});
  const [Jdata, setJData] = useState([]);
  useEffect(() => {
    let temp1 = mainState;
    console.log(temp1, "--------mainState found temp1------");

    var output = [];
    for (let i in temp1) {
      console.log(temp1[i]["variantObj"]);
      for (let j in temp1[i]["variantObj"]) {
        console.log(j);
        console.log(temp1[i]["variantObj"][j]);
        const d = temp1[i]["variantObj"][j];
        d.total !== 0 &&
          output.push({
            name: i,
            basePrice: temp1[i].price,
            thumb: temp1[i].thumb ? temp1[i].thumb : temp1[i].thumb_url,
            discount: isNaN(temp1[i].discount) === true ? 0 : temp1[i].discount,
            price: d["price"],
            quantity: d["quantity"],
            id: d["id"],
            total: d["total"],
            variant: d["name"],
          });
      }
    }
    setJData(output);
  }, [mainState]);

  const convertData = (date) => {
    var current = new Date(date);
    return current.toISOString().substring(0, 10);
  };

  function validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
  }
  const history = useHistory();
  const ValidateData = (sendEmail) => {
    const bd = /^[1][0-9]{9}$/;

    if (InvoiceAllData["invoice_date"] === "") {
      showToast("error", "Invoice  Date can't be empty..");
      return 0;
    } else if (!bd.test(InvoiceAllData["invoice_from_mobile"])) {
      showToast("error", "From Mobile : Please Enter Valid phone number");
      return 0;
    } else if (!bd.test(InvoiceAllData["invoice_to_mobile"])) {
      showToast("error", "To Mobile : Please Enter Valid phone number");
      return 0;
    } else if (!Found && InvoiceAllData["invoice_bill_from"] === "") {
      showToast("error", "Bill from  can't be empty..");
      return 0;
    } else if (!Found && InvoiceAllData["invoice_bill_to"] === "") {
      showToast("error", "Bill to  can't be empty..");
      return 0;
    }

    if (InvoiceAllData["invoice_from_email"] === "") {
      showToast("error", "From email  can't be empty..");
      return 0;
    } else if (!validateEmail(InvoiceAllData["invoice_from_email"])) {
      showToast("error", "From email  not valid..");
      return 0;
    } else if (
      Found &&
      !validateEmail(FoundCustomer?.email) === "" &&
      InvoiceAllData["invoice_to_email"].length > 0
    ) {
      showToast("error", "To email  not valid...");
      return 0;
    } else if (
      !Found &&
      !validateEmail(InvoiceAllData["invoice_to_email"]) &&
      InvoiceAllData["invoice_to_email"].length > 0
    ) {
      showToast("error", "To email  not valid..");
      return 0;
    } else if (InvoiceAllData["invoice_from_address"] === "") {
      showToast("error", "From address  can't be empty..");
      return 0;
    } else if (!Found && InvoiceAllData["invoice_to_address"] === "") {
      showToast("error", "To address  can't be empty..");
      return 0;
    } else if (
      InvoiceAllData["invoice_to_address"].length < 10 &&
      FoundCustomer?.to_address.length < 10
    ) {
      showToast("error", "To address  should be more then 10 character..");
      return 0;
    }

    if (Object.keys(mainState).length <= 0) {
      showToast("error", "Product Details is empty..");
      return 0;
    }

    if (InvoiceAllData["invoice_notes"] === null) {
      showToast("error", "Notes is empty..");
      return 0;
    }
    // if (deliveryService === 1) {
    //   if (!watchFields[0]?.label && !FoundCustomer.to_division) {
    //     showToast("error", "Division is empty..");
    //     return 0;
    //   }

    //   if (!FoundCustomer.to_district && !watchFields[1]?.label) {
    //     showToast("error", "District is empty..");
    //     return 0;
    //   }
    //   if (!FoundCustomer.to_city && !watchFields[2]?.label) {
    //     showToast("error", "City is empty..");
    //     return 0;
    //   }
    // }
    // if (deliveryService === 0) {
    //   if (!pathaoCity?.label) {
    //     showToast("error", "City is empty..");
    //     return 0;
    //   }
    //   if (!pathaoZone?.label) {
    //     showToast("error", "Zone is empty..");
    //     return 0;
    //   }
    //   if (!pathaoArea?.label) {
    //     showToast("error", "Area is empty..");
    //     return 0;
    //   }

    // }

    for (const item in mainState) {
      const variantObj = mainState[item].variantObj;

      // Check if every variantObj.quantity is -1
      const isAllQuantitiesEmpty = Object.values(variantObj).every(
        (variant) => variant.quantity === -1
      );

      if (isAllQuantitiesEmpty) {
        showToast("error", `${item} Quantity is empty`);
        return 0; // Exit the function with 0
      }
    }
    if (deliveryService.value === 1 || deliveryService.value === "1") {
      if (!watchFields[0]?.label && !FoundCustomer.to_division) {
        showToast("error", "Division is empty.");
        return 0;
      } else if (!watchFields[1]?.label && !FoundCustomer.to_district) {
        showToast("error", "District is empty.");
        return 0;
      } else if (!watchFields[2]?.label && !FoundCustomer.to_city) {
        showToast("error", "City is empty.");
        return 0;
      }
    }
    if (deliveryService.value === 0 || deliveryService.value === "0") {
      if (!pathaoCity?.label) {
        showToast("error", "City is empty.");
        return 0;
      } else if (!pathaoZone?.label) {
        showToast("error", "Zone is empty.");
        return 0;
      } else if (!pathaoArea?.label) {
        showToast("error", "Area is empty.");
        return 0;
      }
    }

    postInvoice(sendEmail);
  };

  // };
  // console.log("allvariants", allvariants);

  function formatInv(inputData) {
    const formattedData = [];

    // Iterate over the data object
    for (const key in inputData) {
      const product = inputData[key];
      const variants = product.variant;

      // Iterate over the variants array for each product
      for (let i = 0; i < variants.length; i++) {
        const variant = variants[i];

        // Check if quantity is greater than 0
        if (variant.quantity > 0) {
          // Create a new formatted object using the variant data
          const formattedObject = {
            quantity: variant.quantity,
            total: variant.total.toString(),
            product_name: product.productName || key.split("_")[0], // Use stored product name or extract from key
            variant_name: variant.name,
            is_custom: false,
            invoice_date: InvoiceAllData["invoice_date"],
            product: product.id,
            variant: variant.id,
            is_regular: true,
          };

          // Add the formatted object to the formattedData array
          formattedData.push(formattedObject);
        }
      }
    }

    return formattedData;
  }

  const SaveAndSendEmail = () => {
    ValidateData(true);
  };

  const postInvoice = (sendEmail) => {
    const url = `${BASE_URL}api/v1/sales/inventory/invoice/`;
    const data = new FormData();

    const current_user = JSON.parse(localStorage.getItem("userData"));
    data.append(
      "invoice_date",
      InvoiceAllData["invoice_date"] !== "" &&
        convertData(InvoiceAllData["invoice_date"])
    );

    data.append("bill_from", InvoiceAllData["invoice_bill_from"]);
    data.append(
      "bill_to",
      Found ? FoundCustomer.name : InvoiceAllData["invoice_bill_to"]
    );
    data.append("from_email", InvoiceAllData["invoice_from_email"]);
    data.append(
      "to_email",
      Found ? FoundCustomer.email : InvoiceAllData["invoice_to_email"]
    );
    data.append(
      "from_mobile",
      `+${fromCode}${InvoiceAllData["invoice_from_mobile"]}`
    );
    data.append(
      "to_mobile",
      `+${toCode}${InvoiceAllData["invoice_to_mobile"]}`
    );
    data.append("from_address", InvoiceAllData["invoice_from_address"]);
    data.append(
      "to_address",
      Found ? FoundCustomer.address : InvoiceAllData["invoice_to_address"]
    );
    data.append(
      "delivery_charge",
      parseInt(invoice_delivery_charge) === 2
        ? customCharge
        : delivery_charge[InvoiceAllData["invoice_delivery_charge"]]
    );
    data.append("delivery_charge_type", parseInt(invoice_delivery_charge));

    data.append("total_discount", Discount);
    data.append("send_pdf", sendEmail);

    data.append("discount_type", invoice_discount_type);
    data.append(
      "product_list_json",
      JSON.stringify({
        mainstate: mainState,
        maininnerstate: mainInnerState,
      })
    );

    data.append("invoice_view_json", JSON.stringify(Jdata));

    data.append("payment_status", invoice_status.value);
    data.append("delivery_status", Delivery_status.value);
    data.append("delivery_type", invoice_delivery_type);
    data.append("payment_type", invoice_payment_type);
    data.append("payment_type", invoice_payment_type);
    data.append("card_holder_name", paymentAllData["card_holder_name"]);
    data.append("card_number", paymentAllData["card_number"]);
    data.append("card_expiry_date", paymentAllData["card_expiry_date"]);
    data.append("bank_name", paymentAllData["bank_name"]);
    data.append("banK_account_number", paymentAllData["banK_account_number"]);
    data.append("banK_routing_number", paymentAllData["banK_routing_number"]);
    data.append("banK_account_name", paymentAllData["banK_account_name"]);
    data.append("banK_branch_name", paymentAllData["banK_branch_name"]);
    data.append("bkash_number", paymentAllData["bkash_number"]);
    data.append("bkash_trx_number", paymentAllData["bkash_trx_number"]);
    // data.append("payment_status", 0);
    data.append("signature", null);
    data.append("notes", InvoiceAllData["invoice_notes"]);
    data.append("created_by", current_user.id);
    data.append("total_tax", 0);
    data.append("total_due", parseInt(getDueAmount()));
    data.append("total_paid", paid);
    data.append("total_amount", parseInt(getGrandTotal()));
    data.append("total_vat", 0);
    data.append("invoice_products", JSON.stringify(formatInv(mainState)));

    // SetisLoading(true);
    const data2 = {
      invoice_date:
        InvoiceAllData["invoice_date"] !== "" &&
        convertData(InvoiceAllData["invoice_date"]),
      bill_from: InvoiceAllData["invoice_bill_from"],
      bill_to: Found
        ? InvoiceAllData["invoice_bill_to"]
        : InvoiceAllData["invoice_bill_to"],
      from_email: InvoiceAllData["invoice_from_email"],
      to_email: Found
        ? FoundCustomer.email
        : InvoiceAllData["invoice_to_email"],
      from_mobile: `+${fromCode}${InvoiceAllData["invoice_from_mobile"]}`,
      to_mobile: `+${toCode}${InvoiceAllData["invoice_to_mobile"]}`,
      from_address: InvoiceAllData["invoice_from_address"],
      to_address: Found
        ? FoundCustomer.to_address
        : InvoiceAllData["invoice_to_address"],
      delivery_charge: customCharge,
      // delivery_charge:
      //   parseInt(invoice_delivery_charge) === 2
      //     ? customCharge
      //     : delivery_charge[InvoiceAllData["invoice_delivery_charge"]],
      delivery_charge_type: parseInt(invoice_delivery_charge),
      total_discount: Discount,
      send_pdf: sendEmail,
      discount_type: invoice_discount_type,
      product_list_json: JSON.stringify({
        mainstate: mainState,
        maininnerstate: mainInnerState,
      }),
      invoice_view_json: JSON.stringify(Jdata),
      payment_status: invoice_status.value
        ? invoice_status?.value
        : invoice_status,
      delivery_status: Delivery_status.value
        ? Delivery_status.value
        : Delivery_status,
      delivery_type: invoice_delivery_type,
      payment_type: invoice_payment_type,
      card_holder_name: paymentAllData["card_holder_name"],
      card_number: paymentAllData["card_number"],
      card_expiry_date: paymentAllData["card_expiry_date"],
      bank_name: paymentAllData["bank_name"],
      banK_account_number: paymentAllData["banK_account_number"],
      banK_routing_number: paymentAllData["banK_routing_number"],
      banK_account_name: paymentAllData["banK_account_name"],
      banK_branch_name: paymentAllData["banK_branch_name"],
      bkash_number: paymentAllData["bkash_number"],
      bkash_trx_number: paymentAllData["bkash_trx_number"],
      nagad_number: paymentAllData["nagad_number"],
      nagad_trx_number: paymentAllData["nagad_trx_number"],
      reference_id: paymentAllData["reference_id"],
      signature: null,
      notes: InvoiceAllData["invoice_notes"],
      created_by: current_user.id,
      total_tax: 0,
      total_due: parseInt(getDueAmount()),
      total_paid: paid,
      total_amount: parseInt(getGrandTotal()),
      sub_total: isNaN(getSubTotal()) ? 0 : getSubTotal(),
      total_vat: 0,
      invoice_products: formatInv(mainState),
      to_address2: Found
        ? FoundCustomer.to_address2
        : InvoiceAllData["invoice_to_address2"],
      to_country: Found
        ? FoundCustomer.to_country
        : InvoiceAllData["to_country"],
      to_district: Found ? FoundCustomer.to_district : watchFields[1]?.label,
      redex_division: watchFields[0]?.value,
      redex_district: watchFields[1]?.value,
      redex_area: watchFields[2]?.value,
      to_division: Found ? FoundCustomer.to_division : watchFields[0]?.label,
      to_zip_code: Found ? FoundCustomer.to_zip_code : watchFields[3],
      to_city: Found ? FoundCustomer.to_city : watchFields[2]?.label,
      is_regular: true,
      // pathao data
      delivery_service: deliveryService.value,
      pathao_city_name: pathaoCity.label ? pathaoCity.label : "",
      pathao_city_id: pathaoCity.value ? pathaoCity.value : 0,
      pathao_zone_name: pathaoZone.label ? pathaoZone.label : "",
      pathao_zone_id: pathaoZone.value ? pathaoZone.value : 0,
      pathao_area_name: pathaoArea.label ? pathaoArea.label : "",
      pathao_area_id: pathaoArea.value ? pathaoArea.value : 0,
    };
    setInvoiceLoader(true);

    axios
      .post(url, data2)
      .then((res) => {
        if (res.data.status) {
          // console.log(res);
          // postInvoiceProduct(res.data.data.id);
          // clearData();
          SetisLoading(false);

          showToast("success", "Invoice Created.");
          setInvoiceLoader(false);
          history.push(path.invoice_list);
        }
      })
      .catch((err) => {
        const message = JSON.parse(err.request.response).message;
        const errorMsg = JSON.parse(err.request.response).errors;
        // console.log(errorMsg);
        // for (let value of Object.values(errorMsg)) {
        //   showToast("error", value[0]);
        // }

        for (let key in errorMsg) {
          showToast("error", `${key} : ${errorMsg[key][0]}`);
        }
        showToast("error", message);
        SetisLoading(false);
        setInvoiceLoader(false);
      });
  };
  console.log(InvoiceAllData["invoice_date"], "date");

  // function debounce(func, delay) {
  //   let timeoutId;
  //   return function (...args) {
  //     clearTimeout(timeoutId);
  //     timeoutId = setTimeout(() => {
  //       func.apply(this, args);
  //     }, delay);
  //   };
  // }

  // const debouncedFetch = debounce(getProductList, 1000);

  const inputProduct = (inputValue) => {
    setInputQuery(inputValue);
  };
  console.log(
    {
      mainState: mainState,
      mainInnerState: mainInnerState,
    },
    "855"
  );

  const handleMultiInputChange = useCallback(
    (newValue, actionMeta) => {
      console.log("newValue 123", newValue);
      console.log("newValue 1234", actionMeta?.option?.label);

      if (actionMeta.action === "select-option" && actionMeta?.option) {
        const option = actionMeta.option;
        const productName = option.product_name;
        const variantName = option.variant_name;
        const productSku =
          option.product_sku || option.productSKU || option.product_sku_code;
        const variantSku = option.variant_sku;
        const uniqueKey =
          productSku && variantSku
            ? `${productSku}_${variantName}_${variantSku}`
            : `${productName}_${variantName}`; // Fallback for safety

        console.log("Adding variant:", {
          productName,
          variantName,
          option,
          uniqueKey,
        });

        const parsedPrice =
          option.price !== undefined && option.price !== null
            ? Number(option.price)
            : 0;
        const parsedCalculatedMainPrice =
          option.calculated_main_price !== undefined &&
          option.calculated_main_price !== null
            ? Number(option.calculated_main_price)
            : option.main_price !== undefined && option.main_price !== null
            ? Number(option.main_price)
            : parsedPrice;
        const parsedDiscountType =
          option.discount_type !== undefined && option.discount_type !== null
            ? Number(option.discount_type)
            : null;
        const parsedVariantDiscount =
          option.variant_discount !== undefined &&
          option.variant_discount !== null
            ? Number(option.variant_discount)
            : 0;

        // Check if this specific variant already exists
        if (mainState[uniqueKey]) {
          console.log("Variant already exists, skipping");
          return; // Don't add to defaultValue if variant already exists
        }

        // Create new variant entry with unique key
        const newVariant = {
          id: option.value,
          name: variantName,
          price: parsedPrice,
          stock:
            option.stock !== undefined && option.stock !== null
              ? Number(option.stock)
              : 0,
          product: option.product_id,
          quantity: -1,
          total: 0,
          calculatedMainPrice: parsedCalculatedMainPrice,
          discountType: parsedDiscountType,
          variantDiscount: parsedVariantDiscount,
        };

        const variantsObj = {
          [variantName]: { ...newVariant },
        };

        setMainState((prevMainState) => ({
          ...prevMainState,
          [uniqueKey]: {
            id: option.product_id,
            variant: [newVariant],
            variantObj: variantsObj,
            price: parsedPrice,
            stock:
              option.stock !== undefined && option.stock !== null
                ? Number(option.stock)
                : 0,
            thumb: option.thumb,
            discount: parsedPrice,
            productName: productName, // Store original product name for reference
            productSku: productSku,
            calculatedMainPrice: parsedCalculatedMainPrice,
            variantDiscountType: parsedDiscountType,
            variantDiscountValue: parsedVariantDiscount,
          },
        }));

        // Add to defaultValue
        setdefaultValue((prevDefaultValue) => {
          return [
            ...prevDefaultValue,
            {
              value: option.value,
              label: option.label,
            },
          ];
        });
      }

      //remove data from select
      if (actionMeta.action === "remove-value") {
        const removedOption = actionMeta.removedValue;

        // Check if removedOption and label exist
        if (removedOption) {
          const productSku =
            removedOption.product_sku ||
            removedOption.productSKU ||
            removedOption.product_sku_code;
          const variantSku = removedOption.variant_sku;
          const variantName = removedOption.variant_name;
          let uniqueKey;
          if (productSku && variantSku && variantName) {
            uniqueKey = `${productSku}_${variantName}_${variantSku}`;
          } else if (removedOption.label) {
            // Label e.g.: "Product Name [PRODSKU] - VariantName [[VSKU]]"
            const label = removedOption.label;
            const parts = label.split(" - ");
            if (parts.length >= 2) {
              const left = parts[0];
              const right = parts[1];
              const productSkuMatch = left.match(/\[(.*?)\]$/);
              const parsedProductSku = productSkuMatch
                ? productSkuMatch[1]
                : undefined;
              const parsedVariantName = right.split(" [[")[0];
              const variantSkuMatch = right.match(/\[\[(.*?)\]\]/);
              const parsedVariantSku = variantSkuMatch
                ? variantSkuMatch[1]
                : undefined;
              if (parsedProductSku && parsedVariantName && parsedVariantSku) {
                uniqueKey = `${parsedProductSku}_${parsedVariantName}_${parsedVariantSku}`;
              } else {
                uniqueKey = `${parts[0]}_${parsedVariantName}`;
              }
            }
          }

          if (uniqueKey && mainState[uniqueKey]) {
            const newMainState = { ...mainState };
            delete newMainState[uniqueKey];
            setMainState(newMainState);
          }
        }

        setdefaultValue((prevDefaultValue) =>
          prevDefaultValue.filter(
            (value) =>
              value.label !== actionMeta.removedValue.label &&
              value.value !== actionMeta.removedValue.value
          )
        );
        setScanCode("");
      }
    },
    [mainState, setMainState, setdefaultValue]
  );
  console.log(mainState, "mainState123");

  const getProductList2 = useCallback(() => {
    console.log(scanedCode, "code");
    let url;
    if (scanedCode) {
      url = `${BASE_URL}/api/v1/inventory/inventory/product_list_for_invoice/?query=${scanedCode}`;
    }

    axios
      .get(url)
      .then((res) => {
        // console.log("productlistinvoice", res.data);
        const result = res.data.data;

        // Create variant-based options instead of product-based
        const variantOptions = [];
        result.forEach((product) => {
          product.variants.forEach((variant) => {
            const parsedPrice =
              variant.calculated_price !== undefined &&
              variant.calculated_price !== null
                ? Number(variant.calculated_price)
                : Number(variant.price) || 0;
            const parsedMainPrice =
              variant.calculated_main_price !== undefined &&
              variant.calculated_main_price !== null
                ? Number(variant.calculated_main_price)
                : Number(product.price) || parsedPrice;
            variantOptions.push({
              label: `${product.name} [${product.sku ?? ""}] - ${
                variant.name
              } [[${variant.sku}]]`,
              value: variant.id,
              price: parsedPrice,
              discount: product.discount,
              stock: variant.stock,
              product_id: product.id,
              product_name: product.name,
              product_sku: product.sku,
              variant_name: variant.name,
              variant_sku: variant.sku,
              thumb: product.thumb_url || product.thumb,
              main_price: parsedMainPrice,
              main_discount: product.discount,
              calculated_main_price: parsedMainPrice,
              discount_type: variant.offer_details?.discount_type,
              variant_discount: variant.offer_details?.discount_value,
            });
          });
        });

        console.log(variantOptions, "variant options 921");

        setProductsList(variantOptions);
        setScanCode("");
      })
      .catch((err) => {
        // const message = JSON.parse(err.request.response).message;
        // console.log(err.request.response);
      });
  }, [scanedCode, setProductsList, setScanCode]);

  useEffect(() => {
    if (scanedCode) {
      getProductList2();
    }
  }, [scanedCode, getProductList2]);
  // useEffect(() => {
  //   if(inputQuery?.length > 3){
  //     getProductList();
  //   }
  //   // debouncedFetch()
  // }, [inputQuery]);

  // aftar

  // useEffect(() => {
  //   let timeoutId;
  //   const delayedFetch = () => {
  //     timeoutId = setTimeout(() => {
  //       getProductList();
  //     }, 1000); //
  //   };
  //   delayedFetch();
  //   return () => {
  //     clearTimeout(timeoutId);
  //   };
  // }, [inputQuery]);

  // console.log("CustomerList", CustomerList);
  const toPhoneHandle = (e) => {
    let number = e.target.value;
    handleInputs(e, SetInvoiceAllData);
    if (number.length === 10) {
      const url = `${BASE_URL}/api/v1/inventory/inventory/customer/?limit=20&offset=0&filter=&search=${number}`;
      axios.get(url).then((res) => {
        if (res.data.data.results.length !== 0) {
          setPathaoCity({
            label: res.data.data.results[0].pathao_city_name
              ? res.data.data.results[0].pathao_city_name
              : "",
            value:
              res.data.data.results[0].pathao_city_id === 0
                ? ""
                : res.data.data.results[0].pathao_city_id,
          });

          setPathaoZone({
            label: res.data?.data?.results[0]?.pathao_zone_name,
            value:
              res.data?.data?.results[0]?.pathao_zone_id === 0
                ? ""
                : res.data?.data?.results[0]?.pathao_zone_id,
          });

          setPathaoArea({
            label: res.data?.data?.results[0]?.pathao_area_name
              ? res.data?.data?.results[0]?.pathao_area_name
              : "",
            value:
              res.data?.data?.results[0]?.pathao_area_id === 0
                ? ""
                : res.data?.data?.results[0]?.pathao_area_id,
          });
          setFound(true);
          setFoundCustomer(res.data.data.results[0]);
          showToast("success", "Found Customer");
        } else {
          setFound(false);
        }
      });
    }
  };

  const [paid, setpaid] = useState(0);
  const [Discount, setDiscount] = useState(0);

  const getSubTotal = () => {
    // With the new structure, each entry in mainState has only one variant
    const allarray = Object.values(mainState).map((curr) => {
      if (curr.variant && curr.variant.length > 0) {
        return parseInt(curr.variant[0].total) || 0;
      }
      return 0;
    });

    var sum = 0;
    for (let i in allarray) {
      sum += parseInt(allarray[i]);
    }
    return sum;
  };
  const getFlatDiscount = () => {
    return Discount;
  };

  const getDeliveryCharge = () => {
    if (invoice_delivery_charge === 2) {
      return parseInt(customCharge);
    } else {
      return delivery_charge[invoice_delivery_charge];
    }
  };
  // prev 16april 2024
  // const getPercentageDiscount = () => {
  //   let total = getSubTotal() + parseInt(customCharge);
  //   return parseInt((Discount / 100) * total);
  // };
  // new 16april 2024
  const getPercentageDiscount = () => {
    let total = getSubTotal();
    return parseInt((Discount / 100) * total);
  };
  console.log(customCharge, "getPercentageDiscount");
  const getGrandTotal = () => {
    const discountCalc =
      invoice_discount_type === 0 || invoice_discount_type === "0"
        ? getFlatDiscount()
        : getPercentageDiscount();
    const charge = parseInt(customCharge);
    const beforeGrand = getSubTotal() + charge;
    const grand = beforeGrand - discountCalc;
    return grand < 0 ? 0 : parseInt(grand);
  };

  const getDueAmount = () => {
    const due = getGrandTotal() - paid;
    return due < 0 ? 0 : due;
  };
  const handlePrint = useReactToPrint({
    content: () => print.current,
    documentTitle: "emp-data",
    bodyClass: "dis",
  });
  const handlePrint2 = () => {
    if (
      InvoiceAllData["invoice_from_email"] !== "" ||
      InvoiceAllData["invoice_to_email"] ||
      InvoiceAllData["invoice_bill_to"] ||
      InvoiceAllData["invoice_bill_form"]
    ) {
      handlePrint();
    } else {
      swal("Empty Data,Please fill the form");
    }
  };

  const handleQuantity = (e, curr, variant) => {
    const uniqueKey = curr; // curr is now the uniqueKey (productName_variantName)
    const variantName = variant.name;

    if (e.target.value < 0) {
      setPs(0);
    } else {
      setPs(e.target.value);
    }

    setMainState((prevInputs) => {
      const copiedObjects = Object.assign({}, mainState); // Shallow copy

      if (parseInt(e.target.value) < 0) {
        copiedObjects[uniqueKey]["variant"][0]["quantity"] = 0;
        copiedObjects[uniqueKey]["variantObj"][variantName]["quantity"] = 0;
      } else if (parseInt(e.target.value) > variant.stock) {
        showToast("error", `Max Stock : ${variant.stock}`);
        copiedObjects[uniqueKey]["variant"][0]["quantity"] = 0;
        copiedObjects[uniqueKey]["variantObj"][variantName]["quantity"] = 0;
        copiedObjects[uniqueKey]["variant"][0]["quantity"] = variant.stock;
        copiedObjects[uniqueKey]["variantObj"][variantName]["quantity"] =
          variant.stock;
      } else {
        copiedObjects[uniqueKey]["variant"][0]["quantity"] = parseInt(
          e.target.value
        );
        copiedObjects[uniqueKey]["variantObj"][variantName]["quantity"] =
          parseInt(e.target.value);
      }

      const unitPrice =
        copiedObjects[uniqueKey]["variant"][0]["price"] !== undefined &&
        copiedObjects[uniqueKey]["variant"][0]["price"] !== null
          ? Number(copiedObjects[uniqueKey]["variant"][0]["price"])
          : 0;

      copiedObjects[uniqueKey]["variantObj"][variantName]["price"] = unitPrice;

      // Update the variant in the array
      copiedObjects[uniqueKey]["variant"][0]["total"] =
        parseInt(copiedObjects[uniqueKey]["variant"][0]["quantity"]) *
        unitPrice;

      copiedObjects[uniqueKey]["variantObj"][variantName]["total"] =
        parseInt(
          copiedObjects[uniqueKey]["variantObj"][variantName]["quantity"]
        ) * unitPrice;

      return copiedObjects; // Return copied object
    });
  };
  if (!has_permissions(can_add_invoice)) {
    return <Permission />;
  }
  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <div className="categorey-parent">
        {/* ===============scaner============== */}
        <Scanner2 setScanCode={setScanCode} />
        {/* ===============scaner============== */}

        {/* Product Details Component */}
        <ProductDetails
          mainState={mainState}
          setMainState={setMainState}
          mainInnerState={mainInnerState}
          setMainInnerState={setMainInnerState}
          selectedVariants={selectedVariants}
          setSelectedVariants={setSelectedVariants}
          ProductsList={ProductsList}
          setProductsList={setProductsList}
          defaultValue={defaultValue}
          setdefaultValue={setdefaultValue}
          inputQuery={inputQuery}
          setInputQuery={setInputQuery}
          handleMultiInputChange={handleMultiInputChange}
          inputProduct={inputProduct}
          handleQuantity={handleQuantity}
          getSubTotal={getSubTotal}
          getDeliveryCharge={getDeliveryCharge}
          getGrandTotal={getGrandTotal}
          getDueAmount={getDueAmount}
          customCharge={customCharge}
          setCustomCharge={setCustomCharge}
          Discount={Discount}
          setDiscount={setDiscount}
          paid={paid}
          setpaid={setpaid}
          invoice_discount_type={invoice_discount_type}
          invoice_delivery_charge={invoice_delivery_charge}
          setinvoice_delivery_charge={setinvoice_delivery_charge}
          delivery_charge={delivery_charge}
          isLoading={isLoading}
          pS={pS}
          setPs={setPs}
        />
        {/* Invoice Details Component */}
        <InvoiceDetails
          InvoiceAllData={InvoiceAllData}
          SetInvoiceAllData={SetInvoiceAllData}
          Found={Found}
          FoundCustomer={FoundCustomer}
          setFoundCustomer={setFoundCustomer}
          deliveryService={deliveryService}
          setDeliveryService={setDeliveryService}
          pathaoCity={pathaoCity}
          setPathaoCity={setPathaoCity}
          pathaoZone={pathaoZone}
          setPathaoZone={setPathaoZone}
          pathaoArea={pathaoArea}
          setPathaoArea={setPathaoArea}
          selectedDivision={selectedDivision}
          setSelectedDivision={setSelectedDivision}
          selectedDistrict={selectedDistrict}
          setSelectedDistrict={setSelectedDistrict}
          selectedTown={selectedTown}
          setSelectedTown={setSelectedTown}
          districtList={districtList}
          setDistrictList={setDistrictList}
          upazillaList={upazillaList}
          setUpazillaList={setUpazillaList}
          selectLoading={selectLoading}
          setSelectLoading={setSelectLoading}
          customCharge={customCharge}
          setCustomCharge={setCustomCharge}
          watchFields={watchFields}
          setValue={setValue}
          control={control}
          register={register}
          handleDivisionChange={handleDivisionChange}
          handleDistrictChange={handleDistrictChange}
          handleTownChange={handleTownChange}
          toPhoneHandle={toPhoneHandle}
          fromCode={fromCode}
          setFromCode={setFromCode}
          toCode={toCode}
          setToCode={setToCode}
          invoice_delivery_type={invoice_delivery_type}
          setinvoice_delivery_type={setinvoice_delivery_type}
          invoice_discount_type={invoice_discount_type}
          setinvoice_discount_type={setinvoice_discount_type}
          invoice_delivery_charge={invoice_delivery_charge}
          setinvoice_delivery_charge={setinvoice_delivery_charge}
          delivery_charge={delivery_charge}
          paymentType={paymentType}
          invoice_payment_type={invoice_payment_type}
          setinvoice_payment_type={setinvoice_payment_type}
          paymentAllData={paymentAllData}
          setPaymentAllData={setPaymentAllData}
          clearPaymentALlData={clearPaymentALlData}
          handleInputs={handleInputs}
        />

        {/* Payment Status Component */}
        <PaymentStatus
          invoice_payment_type={invoice_payment_type}
          paymentAllData={paymentAllData}
          setPaymentAllData={setPaymentAllData}
          handleInputs={handleInputs}
          invoice_status={invoice_status}
          setinvoice_status={setinvoice_status}
          Delivery_status={Delivery_status}
          setDelivey_status={setDelivey_status}
          InvoiceAllData={InvoiceAllData}
          SetInvoiceAllData={SetInvoiceAllData}
          invoice_choices1={invoice_choices1}
          delivery_choices={delivery_choices}
        />

        <div
          className="padding-btn-head mb-4 d-flex justify-content-end  bg-white cat-child"
          style={{ border: "0.5px solid #E0E0E0" }}
        >
          <div className="" style={{ marginLeft: "-10px" }}>
            <button
              className={`btn rounded border align-items-center me-2 mt-2 d-none }`}
              disabled={!InvoiceAllData}
              onClick={handlePrint2}
            >
              <DoIcon className="doc" /> Preview PDF
            </button>

            {/* <button onClick={postInvoiceProduct} className="btn rounded border me-2 mt-2"> */}
            {invoiceLoader === false ? (
              <button
                onClick={() => ValidateData(false)}
                // onDoubleClick={() => showToast("success", "Invoice Creating")}
                className="btn rounded border me-2 mt-2"
              >
                Save Invoice
              </button>
            ) : (
              <button disabled className="btn rounded border me-2 mt-2">
                <MoonLoader color="black" size={10} /> Creating...
              </button>
            )}

            <button
              className="btn rounded border me-2 mt-2"
              onClick={() => history.push(path.invoice_list)}
            >
              Cancel
            </button>
            {InvoiceAllData["invoice_to_email"] !== "" &&
              !Found &&
              validateEmail(InvoiceAllData["invoice_to_email"]) && (
                <button
                  onClick={SaveAndSendEmail}
                  onDoubleClick={() => showToast("success", "Invoice Creating")}
                  className="btn rounded border text-white mt-2"
                  style={{ background: "black" }}
                >
                  Save & Send PDF
                </button>
              )}

            {Found &&
              FoundCustomer?.email !== "" &&
              validateEmail(FoundCustomer?.email) && (
                <button
                  onClick={SaveAndSendEmail}
                  onDoubleClick={() => showToast("success", "Invoice Creating")}
                  className="btn rounded border text-white mt-2"
                  style={{ background: "black" }}
                >
                  Save & Send PDF
                </button>
              )}
            <div className="d-none">
              <PreviewCreate
                print={print}
                status={invoice_payment_type}
                Found={Found}
                InvoiceAllData={InvoiceAllData}
                FoundCustomer={FoundCustomer}
                mainState={mainState}
                invStatus={invoice_status}
                Jdata={Jdata}
              ></PreviewCreate>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VariantInvoice;
